export const formatActionText = (action: string): string => {
  const actionMap: Record<string, string> = {
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    bulk_update: 'Bulk Update',
    bulk_delete: 'Bulk Delete',
    distribute: 'Distribute',
  };
  return actionMap[action] || action;
};

export const formatObjectTypeText = (objectTypeName: string): string => {
  const modelMap: Record<string, string> = {
    Content: 'Content',
    Series: 'Series',
    Season: 'Season',
    Playlist: 'Playlist',
    Tag: 'Tag',
    People: 'People',
    Contract: 'Contract',
    Company: 'Company',
    User: 'User',
  };
  return modelMap[objectTypeName] || objectTypeName;
};

export const getActionColor = (action: string): string => {
  const colorMap: Record<string, string> = {
    create: 'green',
    update: 'blue',
    delete: 'red',
    bulk_update: 'orange',
    bulk_delete: 'red',
    distribute: 'purple',
  };
  return colorMap[action] || 'default';
};

export const formatChangedFields = (changedFields: string[] | null): string => {
  if (!changedFields || changedFields.length === 0) return '-';
  return changedFields.join(', ');
};

export const formatDataPreview = (data: Record<string, any> | null): string => {
  if (!data) return '-';

  const preview = JSON.stringify(data, null, 2);
  return preview.length > 100 ? preview.substring(0, 100) + '...' : preview;
};

export const handleActionHistoryError = (error: any): void => {
  console.error('Action History Error:', error);
};
